import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { morph } from '@theme/morph';
import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedProducts extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  async #render() {
    const sectionId = this.dataset.sectionId;
    const currentProductId = this.dataset.currentProductId;
    if (!sectionId) return;

    const viewedProductIds = RecentlyViewed.getProducts().filter((id) => id !== currentProductId);
    if (viewedProductIds.length === 0) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', viewedProductIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const updated = parsed.getElementById(this.id);
      if (!updated || updated.hasAttribute('hidden')) return;

      morph(this, updated);
      this.removeAttribute('hidden');
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[recently-viewed-products] Failed to render:', error);
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
